type FlatPrimitive = string | number | boolean | null;
export type FlatValue = FlatPrimitive | FlatValue[] | { [key: string]: FlatValue };

function isBuffer(obj: { constructor?: { isBuffer?: (x: never) => boolean } } | null | undefined) {
  const isBufferFn = obj?.constructor?.isBuffer;
  return typeof isBufferFn === 'function' ? isBufferFn(obj as never) : false;
}

function keyIdentity(key: string) {
  return key;
}

export interface FlattenOptions {
  delimiter?: string;
  maxDepth?: number;
  safe?: boolean;
  transformKey?: (key: string) => string;
  addBrackets?: boolean;
}

export function flatten<T extends { [key: string]: FlatValue } | FlatValue[], R extends Record<string, FlatValue>>(
  target: T,
  opts?: FlattenOptions,
): R {
  const arrayBrackets = opts?.addBrackets;
  opts = opts || {};

  const delimiter = opts.delimiter || '.';
  const transformKey = opts.transformKey || keyIdentity;
  const output: Record<string, FlatValue> = {};

  function step(
    object: { [key: string]: FlatValue } | FlatValue[],
    prev?: string,
    currentDepth?: number,
    addBrackets?: boolean,
  ) {
    currentDepth = currentDepth || 1;
    Object.keys(object as { [key: string]: FlatValue }).forEach((key) => {
      const value = (object as { [key: string]: FlatValue })[key];
      const isarray = opts?.safe && Array.isArray(value);
      const type = Object.prototype.toString.call(value);
      const isbuffer = isBuffer(value as never);
      const isobject = type === '[object Object]' || type === '[object Array]';

      const childhasbrackets = arrayBrackets && Array.isArray(value);

      let newKey: string;
      if (addBrackets) {
        newKey = prev ? `${prev}[${transformKey(key)}]` : `[${transformKey(key)}]`;
      } else {
        newKey = prev ? `${prev}${delimiter}${transformKey(key)}` : transformKey(key);
      }
      if (
        !isarray &&
        !isbuffer &&
        isobject &&
        value &&
        typeof value === 'object' &&
        Object.keys(value as { [key: string]: FlatValue }).length &&
        (!opts?.maxDepth || currentDepth < opts?.maxDepth)
      ) {
        step(value as { [key: string]: FlatValue }, newKey, currentDepth + 1, childhasbrackets);
      } else {
        (output as Record<string, FlatValue>)[newKey] = value as FlatValue;
      }
    });
  }

  step(target as { [key: string]: FlatValue } | FlatValue[]);

  return output as R;
}
